import React, { CSSProperties } from 'react';
import { Stack, Text, IStackStyles, FontIcon } from '@fluentui/react';
import { useEffect } from 'react';
import { shallowEqual } from 'react-redux';
import { appStyles, resolveThemeColors } from '../../helpers';
import { useAppSelector } from '../../store';

export type PathPart = {
    name: string;
    path: string;
};

type BreadcrumbItemProps = {
    name: string;
    path: string;
    onPathPartClick: (e: React.MouseEvent<HTMLElement>, path: string) => void;
};

const BreadcrumbItem = ({
    name,
    path,
    onPathPartClick,
}: BreadcrumbItemProps) => {
    const colors = useAppSelector(resolveThemeColors, shallowEqual);

    return (
        <Stack horizontal verticalAlign="center" key={name}>
            <Text
                className={appStyles.globalStyles.label}
                style={{ cursor: 'pointer' }}
                onClick={(e): void => onPathPartClick(e, path)}
            >
                {' '}
                {name}
            </Text>
            <Stack verticalAlign="center">
                <FontIcon
                    iconName="ChevronRight"
                    style={{ color: colors.icon, fontSize: 12 }}
                />
            </Stack>
        </Stack>
    );
};

type Props = {
    pathParts: PathPart[];
    containerStyle?: CSSProperties;
    onPathPartClick: (e: React.MouseEvent<HTMLElement>, path: string) => void;
};

const breadcrumbsContainerStyles: IStackStyles = {
    root: {
        width: '100%',
    },
};

export const Breadcrumbs = ({
    pathParts,
    onPathPartClick,
    containerStyle,
}: Props) => {
    const BREADCRUMBS_ID = 'breadcrumbs-id';

    useEffect(() => {
        const breadcrumbs = document.getElementById(BREADCRUMBS_ID);
        if (!breadcrumbs) {
            return;
        }
        breadcrumbs.scrollLeft = breadcrumbs.scrollWidth;
    }, [pathParts.length]);

    return (
        <Stack
            id={BREADCRUMBS_ID}
            horizontal={true}
            tokens={{ childrenGap: 2 }}
            style={containerStyle}
            styles={breadcrumbsContainerStyles}
        >
            {pathParts.map((part) => (
                <BreadcrumbItem
                    key={part.name}
                    name={part.name}
                    path={part.path}
                    onPathPartClick={onPathPartClick}
                />
            ))}
        </Stack>
    );
};
